<template>
  <div class="info-page">
    <crumbs title="新闻信息管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>新闻详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="新闻标题" prop="title">
              <el-input
                v-model="form.title"
                placeholder="请输入新闻标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="副标题" prop="subTitle">
              <el-input
                v-model="form.subTitle"
                placeholder="请输入副标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="图片" prop="imgUploadList">
              <image-upload
                url="/api/achievement/uploadachiattach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :num-limit="1"
                :size-limit="10"
                :multiple="false"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；图片建议比例为9：5；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="来源" prop="newsSource">
              <el-input
                v-model="form.newsSource"
                placeholder="请输入来源"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="新闻类别" prop="industryType">
              <enumerate
                url="/api/news/getindustrytype"
                v-model="form.industryType"
                placeholder="请选择新闻类别"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="publishTime">
              <el-date-picker
                v-model="form.publishTime"
                type="datetime"
                placeholder="请选择发布时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="详情内容" prop="newsContent">
              <editor
                v-model="form.newsContent"
                imgUploadUrl="/api/achievement/uploadachiattach"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.industryType !== 3" :gutter="10">
          <el-col :span="12">
            <el-form-item label="信息推荐" prop="isRecommend">
              <el-switch v-model="form.isRecommend"></el-switch>
              <div
                class="info"
                style="
                  display: inline-block;
                  height: 40px;
                  margin-left: 20px;
                  vertical-align: top;
                "
              >
                <info-tooltip
                  content="开启推荐之后，将在首页-新闻资讯右侧、新闻首页-新闻聚焦右侧展示，多个推荐将按填写的发布时间排序，发布时间最晚的排在最上方"
                  placement="bottom-start"
                />
              </div>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="置顶" prop="isTop">
              <el-switch v-model="form.isTop"></el-switch>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="SEO关键词" prop="seoWords">
              <el-input
                v-model="form.seoWords"
                placeholder="请输入SEO关键词"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="SEO描述" prop="seoDec">
              <el-input
                v-model="form.seoDec"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入SEO描述"
                maxlength="200"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "newsInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        title: "",
        subTitle: "",
        imgUploadList: [], // imgURL 相对应
        newsSource: "",
        industryType: "",
        publishTime: "",
        newsContent: "",
        isRecommend: false,
        isTop: false,
        seoWords: "",
        seoDec: ""
      },
      rules: {
        title: [isEmpty("请输入新闻标题")],
        imgUploadList: [isEmpty("请上传图片", "change")],
        newsSource: [isEmpty("请输入来源")],
        industryType: [isEmpty("请选择新闻类别", "change")],
        publishTime: [isEmpty("请选择发布时间", "change")],
        newsContent: [isEmpty("请编辑详情内容")],
        isRecommend: [isEmpty("请选择是否推荐", "change")],
        isTop: [isEmpty("请选择是否置顶", "change")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        imgUploadList,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgURL = deconstruct(imgUploadList[0]);
      return {
        ...others,
        imgURL
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // 去分号
        imgURL,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imgURL
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      return {
        ...others,
        ...turnFile
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("activity", "addNews", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("activity", "addNews", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("activity", "getNewsInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/activityManage/newsList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
